import styled from "styled-components";

export const BannerWrap = styled.div`
  width: 100%;

  > img {
    width: 100%;
    display: block;
  }
`